// extracted by mini-css-extract-plugin
module.exports = {"account__type":"UserMiniProfile_account__type__2J1LA","username":"UserMiniProfile_username__1AiTk"};